import {Component, ElementRef, OnInit, Renderer2, ViewEncapsulation} from '@angular/core';
import {BackendEvents} from './shared/backend-events';
import {NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';
import {BrowserEvents} from '../common/core/services/browser-events.service';
import {TitleService} from '../common/core/services/title.service';
import {Settings} from '../common/core/config/settings.service';
import {AppHttpClient} from '../common/core/http/app-http-client.service';
import {filter} from 'rxjs/operators';
import {CustomHomepage} from '../common/core/pages/custom-homepage.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    public isLoading = false;

    constructor (
        private el: ElementRef,
        private browserEvents: BrowserEvents,
        private renderer: Renderer2,
        private backendEvents: BackendEvents,
        private title: TitleService,
        private settings: Settings,
        private router: Router,
        private httpClient: AppHttpClient,
        private customHomepage: CustomHomepage,
    ) { }

    ngOnInit() {
        this.browserEvents.subscribeToEvents(this.el.nativeElement);
        this.settings.setHttpClient(this.httpClient);

        // google analytics
        if (this.settings.get('analytics.tracking_code')) {
            this.triggerAnalyticsPageView();
        }

        // custom homepage
        this.customHomepage.select();

        this.title.init();
        this.backendEvents.init();
        this.enableTransitionOnChunkLoad();

    }

    /**
     * Show a transition animation when chunks
     * are being lazy loaded by angular.
     */
    private enableTransitionOnChunkLoad() {
        this.router.events
            .subscribe(e => {
                if (e instanceof RouteConfigLoadStart) {
                    this.isLoading = true;
                } else if (e instanceof RouteConfigLoadEnd) {
                    this.isLoading = false;
                }
            });
    }

    private triggerAnalyticsPageView() {
        this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                if ( ! window['ga']) return;
                window['ga']('set', 'page', event.urlAfterRedirects);
                window['ga']('send', 'pageview');
            });
    }
}
